import { HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ApiHistorie, ApiHistorieDetails } from "@app/core/api/model/api-historie";
import { ProposalHistory, ProposalHistoryDetails } from "@app/core/domain/proposal-history";
import { ApiMappingService } from "@core/mapping/api-mapping.service";
import { GenericHttpService } from "@core/services/generic-http.service";
import { map, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ProposalHistoryService extends GenericHttpService {
  private readonly mappingService = inject(ApiMappingService);

  fetchProposalHistory(planId: number): Observable<ProposalHistory | undefined> {
    const url = `plan/${planId}/historie`;

    return this.httpGet<ApiHistorie | undefined>(url).pipe(
      map((apiHistorie) => (apiHistorie ? this.mappingService.toProposalHistory(apiHistorie) : undefined)),
    );
  }

  fetchProposalHistoryDetails(
    planId: number,
    hsplId: number,
    studentNr: string,
  ): Observable<ProposalHistoryDetails | undefined> {
    const url = `plan/${planId}/historie/${hsplId}`;

    return this.httpGet<ApiHistorieDetails>(url, {} as HttpParams, this.getStudentNrHeader(studentNr)).pipe(
      map((plan) => {
        return plan ? this.mappingService.toProposalHistoryDetails(plan) : undefined;
      }),
    );
  }

  getDocument(documentId: number, studentNr: string): Observable<Blob> {
    const url = `plan/documenten/${documentId}/bestand`;

    return this.httpGetBlob(url, this.getStudentNrHeader(studentNr));
  }
}
